module.exports = __webpack_public_path__ + "static/media/cost.f26741e5.png";